import { render, staticRenderFns } from "./ContactFormPreRegister.vue?vue&type=template&id=36043c60&scoped=true&"
import script from "./ContactFormPreRegister.vue?vue&type=script&lang=js&"
export * from "./ContactFormPreRegister.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormPreRegister.vue?vue&type=style&index=0&id=36043c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36043c60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
